import React from 'react';
import { Accordion } from 'react-bootstrap';
import { CheckCircleTwoTone } from '@ant-design/icons';
import AsyncStbButton from '../../../../atoms/button/AsyncStbButton';
import PlanForConductTemplate from '../../../../organisms/PlanForConductTemplate';
import { PlanForConduct } from '../../../../../api';

interface PlanForConductAccordionItemProps {
    planForConductData: PlanForConduct | undefined;
    setPlanForConductData: React.Dispatch<React.SetStateAction<PlanForConduct | undefined>>;
    planForConductCompletionStatus: boolean;
    workerView: boolean;
    isWeatherProtectionProject?: boolean;
    onApprove: () => Promise<void>;
}

const PlanForConductAccordionItem: React.FC<PlanForConductAccordionItemProps> = ({
    planForConductData,
    setPlanForConductData,
    planForConductCompletionStatus,
    workerView,
    isWeatherProtectionProject,
    onApprove,
}) => {
    return (
        <>
            {planForConductData &&
                <Accordion.Item className='accordion-item shadow fw-bold' eventKey="7" >
                    <Accordion.Header className={workerView ? "disabled-header" : ""}>
                        Plan för uppförande
                        {planForConductCompletionStatus && <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '25px', marginLeft: '10px' }} />}
                    </Accordion.Header>
                    <Accordion.Body className={workerView ? "disabled-body" : ""}>
                        <fieldset disabled={workerView} className="border-0 m-0 p-0 w-100">
                            <PlanForConductTemplate
                                planForConduct={planForConductData}
                                setPlanForConduct={setPlanForConductData}
                                isWeatherProtectionProject={isWeatherProtectionProject}
                            />
                        </fieldset>
                        {!workerView && (
                            <div className="stb-action-bar">
                                <AsyncStbButton type="button" variant="primary" onClick={onApprove}>
                                    Godkänn
                                </AsyncStbButton>
                            </div>
                        )}
                    </Accordion.Body>
                </Accordion.Item>
            }
        </>
    );
};

export default PlanForConductAccordionItem; 
